var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_arrow_back"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 52 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2929 19.707L3.58579 11.9999L11.2929 4.29282L12.7071 5.70703L7.41421 10.9999H20V12.9999H7.41421L12.7071 18.2928L11.2929 19.707Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowBack);
export default __webpack_public_path__ + "static/media/ic_arrow_back.4c00f79ef0fbae855b891d8cde961a3d.svg";
export { ForwardRef as ReactComponent };